// noUiSlider non è più importato staticamente: erano ~28 KB di JS più 4 KB di
// CSS su OGNI pagina, mentre gli slider esistono solo nel riquadro rata della
// home (components/home/slider-rata.blade.php). Liste e schede non ne hanno.
//
// Chi li usa fa `await window.loadNoUiSlider()` e poi trova window.noUiSlider
// al suo posto, quindi il codice esistente non cambia.

let noUiSliderPromise = null;

window.loadNoUiSlider = function () {
    if (!noUiSliderPromise) {
        noUiSliderPromise = Promise.all([
            import('nouislider'),
            import('nouislider/dist/nouislider.min.css'),
        ]).then(([module]) => {
            window.noUiSlider = module;
            return module;
        });
    }
    return noUiSliderPromise;
};
